import { render, staticRenderFns } from "./c-upload.vue?vue&type=template&id=33ef6cfc&"
import script from "./c-upload.vue?vue&type=script&lang=js&"
export * from "./c-upload.vue?vue&type=script&lang=js&"
import style0 from "./c-upload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports